import { Injectable } from '@angular/core';
//import { Observable } from 'rxjs/Observable';
import { Observable, of } from 'rxjs';
//import 'rxjs/add/operator/map';
//import 'rxjs/add/operator/do';
//import 'rxjs/add/operator/catch';
import { IPagination } from '../_interfaces/pagination'
import { IPositionsdatenFelder } from '../_interfaces/positionsdaten-felder';
//import { IChoiceList } from '../_interfaces/_choice-list';
import * as moment from 'moment'; // DateTimeOffset-Fix
import * as cloneDeep from 'lodash/cloneDeep'; // DateTimeOffset-Fix

import { AppconfigService } from '../_services/appconfig.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';

import { CRUDBasicService, httpOptions } from '../_services/crud-basic.service';

import { IChecklistePosition } from '../_interfaces/checkliste-position';

@Injectable()
export class PositionsdatenFelderService extends CRUDBasicService {

  //typeOf deprecated -> CRUDBasicService.propertyTypeOf
  /*typeOf(propertyName: string) {  // welchen Typs sind die Properties IN DER API ?
    let property = this.propertyTypes.find(f => f.name == propertyName);
    if(property != null) return property.type;
    else return null;    
  }*/
  propertyTypes = [ // welchen Typs sind die Properties IN DER API ?
    {name: 'id', type: 'int'},
    {name: 'createdBy', type: 'string'},
    {name: 'created', type: 'DateTimeOffset'},
    {name: 'modifiedBy', type: 'string'},
    {name: 'modified', type: 'DateTimeOffset'},
    {name: 'rowVersion', type: 'byte[]'},
    {name: 'reihenfolge', type: 'int'},
    {name: 'bezeichnung', type: 'string'},
    {name: 'bemerkung', type: 'string'},
    {name: 'platzhalter', type: 'string'},
    {name: 'feldwert', type: 'string'},
    {name: 'typ', type: 'string'},
    {name: 'felddefinition', type: 'string'}
  ];
    
  getPositionsdatenFelderCollection(pageNumber: number, pageSize: number, searchQuery: string): Observable<{ positionsdatenFelder: IPositionsdatenFelder[], pagination: IPagination }> {
    return this.httpClient.get(this.apiBaseUrl + 'positionsdatenfelder?pageNumber=' + pageNumber + '&pageSize=' + pageSize + '&searchQuery=' + searchQuery, { headers: httpOptions, observe: 'response', withCredentials: true })
      .pipe(
        map((response) => {
          return { positionsdatenFelder: <IPositionsdatenFelder[]>response.body, pagination: <IPagination>JSON.parse(response.headers.get('x-pagination')) };
        }), catchError(this.handleError))
  }

  getPositionsdatenFelder(id: number): Observable<IPositionsdatenFelder> {

    if (id === 0) {
      // return Observable.create((observer: any) => {
      //   observer.next(this.initializePositionsdatenFelder());
      //   observer.complete();
      // })
      return of(this.initializePositionsdatenFelder());
    }

    return this.httpClient.get<IPositionsdatenFelder>(this.apiBaseUrl + 'positionsdatenfelder/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError));
  }

  savePositionsdatenFelder(positionsdatenFelder: IPositionsdatenFelder): Observable<IPositionsdatenFelder> {
    // DateTimeOffset-Fix
    let itemToSave = cloneDeep(positionsdatenFelder); // clonen, um sicherzustellen, dass das Original-Objekt nicht ver�ndert wird, evtl. passiert nach dem Save noch etwas damit ?
    //console.log("PositionsdatenFelderService.saveSingularCapitalized#() itemToSave before DateTimeOffset-Fix:", itemToSave);
    this.propertyTypes.filter(f => f.type.toLowerCase() == 'datetimeoffset').forEach(propertyType => {
      if (itemToSave[propertyType.name] != null) {
        itemToSave[propertyType.name] = moment(itemToSave[propertyType.name]).format('YYYY-MM-DDTHH:mm:ss.SSSZ'); // alle datetimeoffset-felder entspr. formatieren, dass in der API auch der Offset ankommt!
      }
    });
    //console.log("PositionsdatenFelderService.saveSingularCapitalized#() itemToSave after DateTimeOffset-Fix:", itemToSave);

    if (positionsdatenFelder.id === 0) {
      return this.createPositionsdatenFelder(/*positionsdatenFelder*/itemToSave);
    }

    return this.updatePositionsdatenFelder(/*positionsdatenFelder*/itemToSave)

  }

  updatePositionsdatenFelder(positionsdatenFelder: IPositionsdatenFelder): Observable<IPositionsdatenFelder> {

    return this.httpClient.put<IPositionsdatenFelder>(this.apiBaseUrl + 'positionsdatenfelder/' + positionsdatenFelder.id, positionsdatenFelder, { headers: httpOptions, observe: 'body', withCredentials: true })
    .pipe(catchError(this.handleError))

  }

  deletePositionsdatenFelder(id: number) {

    return this.httpClient.delete(this.apiBaseUrl + 'positionsdatenfelder/' + id, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(
        catchError(this.handleError)
      )
  }

  createPositionsdatenFelder(positionsdatenFelder: IPositionsdatenFelder): Observable<IPositionsdatenFelder> {
    return this.httpClient.post<IPositionsdatenFelder>(this.apiBaseUrl + 'positionsdatenfelder', positionsdatenFelder, { headers: httpOptions, observe: 'body', withCredentials: true })
      .pipe(map((response) => response), catchError(this.handleError))
  }

  initializePositionsdatenFelder(): IPositionsdatenFelder {
    return {
      id: 0,
      createdBy: '',
      created: /*''*/'0001-01-01T00:00:00.000Z', // fix
      modifiedBy: '',
      modified: /*''*/'0001-01-01T00:00:00.000Z', // fix
      rowVersion: '',
      reihenfolge: 0,
      bezeichnung: '',
      bemerkung: '',
      platzhalter: '',
      feldwert: '',
      typ: '',
      felddefinition: '',

      positionsdaten: null,
      positionsdatenId: null,
      checklistePositionenFeld: null,
      checklistePositionenFeldId: null,
    };
  }


}
